<button
  #buttonElement
  [ngClass]="getButtonClasses()"
  [disabled]="disabled"
  [type]="isSubmit ? 'submit' : 'button'"
  (click)="onButtonClick()"
  [matTooltip]="tooltip"
  [matTooltipShowDelay]="tooltipShowDelay">
  {{ text }}
</button>
